import {Button, List, Stack, Typography} from '@mui/material';
import React from 'react';

import {DataInfo} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import {formatText} from 'presentation/utils';
import {StyledCard} from './styles';
import {ContentProps, HeaderProps, RootProps} from './types';

const {change} = translations['pt-br'].commons;

function Root({children}: RootProps) {
	return <StyledCard elevation={0}>{children}</StyledCard>;
}

function Header({handleAction, subheader, actionDataTagId}: HeaderProps) {
	return (
		<Stack flexDirection="row" justifyContent="space-between" alignItems="center" mb={1}>
			<Typography variant="subheader">{subheader}</Typography>
			{handleAction ? (
				<Button
					variant="text"
					size="small"
					onClick={handleAction}
					data-tag-id={actionDataTagId}>
					{change}
				</Button>
			) : null}
		</Stack>
	);
}

function Content({
	iconName,
	primaryText,
	secondaryText,
	children,
	disablePrimaryTextFormat,
	primaryTextColor,
	secondaryTextColor,
}: ContentProps) {
	return (
		<List disablePadding>
			<DataInfo
				primaryText={disablePrimaryTextFormat ? primaryText : formatText(primaryText)}
				primaryTextColor={primaryTextColor}
				iconName={iconName}
				secondaryText={secondaryText}
				secondaryTextColor={secondaryTextColor}
				removeItemTextMargin
				listItemProps={{sx: {p: 0}}}
			/>
			{children}
		</List>
	);
}

export const ReviewCard = {
	Root,
	Header,
	Content,
};
